
























































import EmphasysRow from "@/components/Atoms/emphasys-row.vue";
import { defineComponent, getCurrentInstance, onMounted, ref } from "vue";
import { mapActions, mapState } from "vuex";

type PrestadorSendoDescredenciado = {
  codigoRede: string;
  codigoPrestadorDescredenciado: string;
  descricaoPrestadorDescredenciado: string;
  srEnderecoDescredenciado: string;
  enderecoPrestadorDescredenciado: string;
  dataDescredenciamento: string;
  motivoDescredenciamento: string;
  contatoDescredenciamento: string;
  emailDescredenciamento: string;
  nomeAssociado: string;
  listado: boolean;
  codigoPrestadorIndicado: string;
  descricaoPrestadorIndicado: string;
  srEnderecoIndicado: string;
  enderecoPrestadorIndicado: string;
  telefonePrestadorIndicado: string;
  dataIndicado: string;
};

export default defineComponent({
  components: {
    EmphasysRow
  },
  setup() {
    const prestador = ref<PrestadorSendoDescredenciado>();
    const context = getCurrentInstance().proxy;

    const irParaDetalhes = async () => {
      context.$root.$emit("show-loading");
      await context["registrarCienteAvisoDescredenciamento"]({
        codigoPrestador: prestador.value.codigoPrestadorDescredenciado,
        srEndereco: prestador.value.srEnderecoDescredenciado
      });
      await context.$router.push({
        name: "affiliate.docInfo",
        params: {
          situacao: "A",
          rede: prestador.value.codigoRede,
          cdPrestador: prestador.value.codigoPrestadorDescredenciado,
          srEndereco: prestador.value.srEnderecoDescredenciado
        }
      });
    };

    onMounted(async () => {
      context.$root.$emit("hide-back-button");
      context.$root.$emit("hide-header-options");
      const prestadoresSendoDescredenciados = context["prestadoresSendoDescredenciados"] as
        | PrestadorSendoDescredenciado[];
      context.$root.$emit("show-loading");
      if (!prestadoresSendoDescredenciados?.length) {
        context.$router.replace("/");
        return;
      }
      const _prestador = prestadoresSendoDescredenciados.find(p => !p.listado);
      if (
        !_prestador?.codigoPrestadorDescredenciado ||
        !_prestador?.descricaoPrestadorDescredenciado ||
        !_prestador?.srEnderecoDescredenciado ||
        !_prestador?.dataDescredenciamento ||
        !_prestador?.motivoDescredenciamento
      ) {
        context.$router.replace("/");
        return;
      }
      _prestador.motivoDescredenciamento = _prestador?.motivoDescredenciamento?.trim() ?? "";
      if (_prestador.motivoDescredenciamento.endsWith(".") ?? false) {
        _prestador.motivoDescredenciamento = _prestador.motivoDescredenciamento.substring(
          0,
          _prestador.motivoDescredenciamento.length - 1
        );
      }
      prestador.value = _prestador;
      context.$root.$emit("hide-loading");
    });

    return {
      prestador,
      irParaDetalhes
    };
  },
  computed: {
    ...mapState("affiliate", ["prestadoresSendoDescredenciados"])
  },
  methods: {
    ...mapActions("affiliate", ["registrarCienteAvisoDescredenciamento"])
  }
});
